import { StyleSheet } from 'react-native';

import {
    Color,
    FontFamily,
    FontSize,
    Padding,
    Stroke,
} from '@/styles/GlobalStyles';

export const styles = StyleSheet.create({
    card: {
        backgroundColor: Color.gray.white,
        borderRadius: 8,
        padding: Padding.p_base,
        marginBottom: 12,
        borderWidth: 1,
        borderColor: Color.gray[100],
        width: '100%',
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 8,
    },
    label: {
        color: Color.gray[300],
        fontFamily: FontFamily.regular,
        fontSize: FontSize.sm,
    },
    value: {
        color: Color.gray[400],
        fontFamily: FontFamily.medium,
        fontSize: FontSize.sm,
        flex: 1,
        textAlign: 'right',
    },
    statusContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    },
    icon: {
        height: 20,
        width: 20,
        strokeWidth: Stroke[2],
    },
    separator: {
        height: 1,
        backgroundColor: Color.gray[100],
        marginVertical: 8,
    },
});
